import { httpClient } from '@/network/clientController'

/** Get metadata to use for card request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardscorebankingrequestmetadata
*/
export const getMetadataForCardRequest = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'cards/corebanking/request/metadata',
        params: payload,
		isCancellable: true
	})
}

/** Request new Card for client
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cardscorebankingrequest
*/
export const requestNewCard = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'cards/corebanking/request',
        data: payload,
		isCancellable: true,
		operationTypeId: 5019 /* for mocks handling of tokens */
	})
}
